const DB_NAME = 'joii_entitlement_lookup';
const STORE_NAME = 'lookup';
const DB_VERSION = 1;

function openDb(): Promise<IDBDatabase> {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, DB_VERSION);
    request.onerror = () => reject(request.error);
    request.onsuccess = () => resolve(request.result);
    request.onupgradeneeded = (event) => {
      const db = (event.target as IDBOpenDBRequest).result;
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME, { keyPath: 'email' });
      }
    };
  });
}

export function getByKey<T>(key: string): Promise<T | null> {
  return openDb().then((db) => {
    return new Promise<T | null>((resolve, reject) => {
      const tx = db.transaction(STORE_NAME, 'readonly');
      const store = tx.objectStore(STORE_NAME);
      const request = store.get(key);
      request.onerror = () => {
        db.close();
        reject(request.error);
      };
      request.onsuccess = () => {
        db.close();
        resolve((request.result as T) ?? null);
      };
    });
  });
}

export function putByKey<T extends { email: string }>(key: string, value: T): Promise<void> {
  return openDb().then((db) => {
    return new Promise<void>((resolve, reject) => {
      const tx = db.transaction(STORE_NAME, 'readwrite');
      const store = tx.objectStore(STORE_NAME);
      const request = store.put({ ...value, email: key });
      request.onerror = () => {
        db.close();
        reject(request.error);
      };
      request.onsuccess = () => {
        db.close();
        resolve();
      };
    });
  });
}

export function deleteByKey(key: string): Promise<void> {
  return openDb().then((db) => {
    return new Promise<void>((resolve, reject) => {
      const tx = db.transaction(STORE_NAME, 'readwrite');
      const store = tx.objectStore(STORE_NAME);
      const request = store.delete(key);
      request.onerror = () => {
        db.close();
        reject(request.error);
      };
      request.onsuccess = () => {
        db.close();
        resolve();
      };
    });
  });
}

export function iterateEntries<T>(): Promise<Array<{ key: string; value: T }>> {
  return openDb().then((db) => {
    return new Promise<Array<{ key: string; value: T }>>((resolve, reject) => {
      const tx = db.transaction(STORE_NAME, 'readonly');
      const store = tx.objectStore(STORE_NAME);
      const request = store.openCursor();
      const results: Array<{ key: string; value: T }> = [];

      request.onerror = () => {
        db.close();
        reject(request.error);
      };

      request.onsuccess = () => {
        const cursor = request.result;
        if (cursor) {
          results.push({ key: cursor.key as string, value: cursor.value as T });
          cursor.continue();
        } else {
          db.close();
          resolve(results);
        }
      };
    });
  });
}
